import { PAYMENT_METHOD_IDS } from "../utils/constants";
import { FilteredPaymentMethod } from "../types/store/common";
import { useGlobalStore, useOrderStore } from "../store/hooks/useStore";
import { FetchPaymentMethodsPayload } from "braintree-web";

interface PaymentMethodData {
    isAvailable: boolean
    isDisabled: boolean
    isLoading: boolean,
    name: string,
    customIconURL?: string
}

export const usePaymentMethodData = (paymentMethod: FetchPaymentMethodsPayload | FilteredPaymentMethod): PaymentMethodData => {
        let isAvailable = true
        let isDisabled = false
        let isLoading = true
        let name = '' 
        let customIconURL
        const { klarnaSetupData } = useOrderStore()
        const globalStore = useGlobalStore()
        
        if('id' in paymentMethod) {
            name = paymentMethod.name
            switch (paymentMethod.id) {
                case PAYMENT_METHOD_IDS.KLARNA:
                    isAvailable = klarnaSetupData.client_token !== undefined
                    isDisabled = !klarnaSetupData.show_form
                    isLoading = !klarnaSetupData.button_rendered
                    name = klarnaSetupData.category?.name || paymentMethod.name
                    customIconURL = klarnaSetupData.category?.asset_urls?.standard || undefined
                    break;
                case PAYMENT_METHOD_IDS.APPLE_PAY:
                    isLoading = !globalStore.hasApplePayButtonRendered
                    break;
    
                default:
                    break;
            }
        }


        return {
            isAvailable,
            isLoading,
            isDisabled,
            name,
            customIconURL
        }
}